var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAndroidLicense(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74,
    height: 58,
    viewBox: "0 0 74 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.276,
    y1: 0.653,
    x2: 0.735,
    y2: 0.447,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b9261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#229a4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#44a560"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#42a95f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44ac66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.276,
    y1: 0.347,
    x2: 0.735,
    y2: 0.553,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 1,
    r: 1.159,
    gradientTransform: "translate(0.275 0.221) scale(0.45 0.863)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4faa63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.764,
    stopColor: "#4daf60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7fa186"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.5,
    cy: 1,
    r: 1.159,
    gradientTransform: "translate(0.275 0.158) scale(0.45 0.863)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 0.788,
    y1: 0.274,
    x2: 0.118,
    y2: 0.695,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0e2010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#050208"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.818,
    stopColor: "#09130b"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 0.5,
    cy: 1,
    r: 1.159,
    gradientTransform: "translate(0.275 0.221) scale(0.45 0.863)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#51aa63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.287,
    stopColor: "#44aa59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.764,
    stopColor: "#4daf60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#61a76a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7fa186"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 0.5,
    cy: 0,
    r: 1.159,
    gradientTransform: "matrix(0.45, 0, 0, -0.863, 0.275, -0.084)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 0.276,
    y1: 0.653,
    x2: 0.735,
    y2: 0.447,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.078,
    stopColor: "#3b9261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#229a4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#44a560"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#42a95f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44ac66"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path25034",
    d: "M184.244,113.913a2.7,2.7,0,0,0-2.534,2.836,3.112,3.112,0,0,0,.278,1.286l4.867,9.374,3.475-.464,1.193-2.168-5.2-9.654a2.466,2.466,0,0,0-2.076-1.209Z",
    transform: "translate(-181.71 -113.913)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 0.543,
    y1: 0.411,
    x2: 0.118,
    y2: 0.185,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7cbc95",
    stopOpacity: 0.365
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b6d2bb",
    stopOpacity: 0.651
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M.277,4.122A3.113,3.113,0,0,1,0,2.836,3.028,3.028,0,0,1,.625.971h0L.67.915l0-.006L.686.9.694.885.7.874.715.861.723.853.742.831l0,0L.762.808.767.8.784.785l0,0L.807.761l0,0L.875.692h0A2.426,2.426,0,0,1,2.054.051h0L2.084.045h0L2.114.039h0l.06-.01h.006l.024,0h.007l.024,0h.005L2.3.011h.008l.021,0h.01l.021,0h.009l.059,0h.1A2.452,2.452,0,0,1,4.565,1.138l.045.07,5.2,9.654L8.62,13.031l-3.476.464Z",
    transform: "translate(0 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 0.428,
    y1: 0.134,
    x2: 0.717,
    y2: 0.746,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4bb064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.271,
    stopColor: "#90ca9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90ca9e",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -2.94,
    y1: 0.653,
    x2: -2.481,
    y2: 0.447,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path25034-5",
    "data-name": "path25034",
    d: "M2.534,13.5A2.7,2.7,0,0,1,0,10.66,3.112,3.112,0,0,1,.278,9.374L5.145,0,8.62.464,9.813,2.632l-5.2,9.654A2.466,2.466,0,0,1,2.534,13.5Z",
    fill: "url(#linear-gradient-9)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 0.543,
    y1: 0.589,
    x2: 0.118,
    y2: 0.815,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -2.94,
    y1: 0.653,
    x2: -2.481,
    y2: 0.447,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f9765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#449a5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#229a4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#44a560"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#42a95f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44ac66"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M.277,9.373A3.113,3.113,0,0,0,0,10.659a3.028,3.028,0,0,0,.625,1.865h0l.044.055,0,.006.011.014.009.01L.7,12.62l.011.013.008.009.019.022,0,0,.018.02,0,.005.017.018,0,0,.019.02,0,0,.067.068h0a2.426,2.426,0,0,0,1.178.641h0l.029.006h0l.027.005h0l.06.01h.006l.024,0h.007l.024,0h.005l.06.007h.008l.021,0h.01l.021,0h.009l.059,0h.1a2.452,2.452,0,0,0,2.031-1.138l.045-.07,5.2-9.654L8.62.464,5.144,0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 0.409,
    y1: 0.627,
    x2: 0.653,
    y2: 0.362,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#41ad59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433,
    stopColor: "#89cb95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82cc8c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 0.402,
    y1: 1,
    x2: 0.598,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#409462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83b785"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 0.788,
    y1: 0.274,
    x2: 0.118,
    y2: 0.695,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0e2010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#050208"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#0c090e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001406"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path19192",
    d: "M202.125,121.734c-15.023.012-27.616,12.711-29.186,29.433h58.392C229.759,134.437,217.155,121.735,202.125,121.734Z",
    transform: "translate(-172.938 -121.734)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 0.502,
    x2: 0.502,
    y2: 0.954,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a7d4aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526,
    stopColor: "#9acfa1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89c98f"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: 0.5,
    cy: 0.5,
    r: 0.449,
    gradientTransform: "translate(0.148 -0.025) scale(1.112 1.112)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#010001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#010203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001000"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path19200",
    d: "M142.86,85.958c-15.023.012-27.616,12.711-29.187,29.433h58.393C170.5,98.661,157.891,85.959,142.86,85.958Z",
    transform: "translate(-113.674 -85.958)",
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ellipse32051",
    d: "M2.855-.058A2.991,2.991,0,0,1,5.648,3.235,3.282,3.282,0,0,1,2.732,6.643,2.991,2.991,0,0,1-.061,3.351,3.282,3.282,0,0,1,2.855-.058Z",
    transform: "matrix(0.985, -0.174, 0.174, 0.985, 0, 1.106)",
    fill: "url(#linear-gradient-17)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 0.132,
    y1: 0.817,
    x2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#85ac8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6ec57e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path41264-5",
    "data-name": "path41264",
    d: "M29.186,29.433C14.163,29.422,1.57,16.722,0,0H58.392C56.821,16.73,44.217,29.433,29.186,29.433Z",
    fill: "url(#radial-gradient-7)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 0.132,
    y1: 0.183,
    x2: 1,
    y2: 1,
    xlinkHref: "#linear-gradient-37"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1019",
    "data-name": "Group 1019",
    transform: "translate(-488 -89)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_477",
    "data-name": "Rectangle 477",
    width: 74,
    height: 58,
    rx: 6,
    transform: "translate(488 89)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g42526",
    transform: "translate(323.005 -15.067)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g28183",
    transform: "translate(181.502 113.913)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path7721",
    d: "M184.244,113.913a2.7,2.7,0,0,0-2.534,2.836,3.114,3.114,0,0,0,.278,1.286l4.867,9.374,3.475-.464,1.193-2.168-5.2-9.654A2.466,2.466,0,0,0,184.244,113.913Z",
    transform: "translate(-181.71 -113.913)",
    fill: "url(#linear-gradient-19)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_529",
    "data-name": "Group 529",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path24395",
    d: "M181.705,116.131c1.447-1.18,2.814-1.522,4.17-.572l4.766,10.011,2-1.355-3.4-9.778-4.085-2.378-3.631,2.209Z",
    transform: "translate(-181.705 -114.085)",
    fill: "url(#linear-gradient-20)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_530",
    "data-name": "Group 530",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path28163",
    d: "M181.705,116.131c1.447-1.18,2.814-1.522,4.17-.572l4.766,10.011,2-1.355-3.4-9.778-4.085-2.378-3.631,2.209Z",
    transform: "translate(-181.705 -114.085)",
    fill: "url(#linear-gradient-20)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path28171",
    d: "M184.244,113.913a2.7,2.7,0,0,0-2.534,2.836,3.114,3.114,0,0,0,.278,1.286l4.867,9.374,3.475-.464,1.193-2.168-5.2-9.654A2.466,2.466,0,0,0,184.244,113.913Z",
    transform: "translate(-181.71 -113.913)",
    fill: "url(#linear-gradient-19)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_531",
    "data-name": "Group 531",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path28173",
    d: "M181.705,116.131c1.447-1.18,2.814-1.522,4.17-.572l4.766,10.011,2-1.355-3.4-9.778-4.085-2.378-3.631,2.209Z",
    transform: "translate(-181.705 -114.085)",
    fill: "url(#linear-gradient-20)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_532",
    "data-name": "Group 532",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path28175",
    d: "M181.705,116.131c1.447-1.18,2.814-1.522,4.17-.572l4.766,10.011,2-1.355-3.4-9.778-4.085-2.378-3.631,2.209Z",
    transform: "translate(-181.705 -114.085)",
    fill: "url(#linear-gradient-20)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_537",
    "data-name": "Group 537",
    transform: "translate(181.502 113.914)",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path39742",
    d: "M191.337,123.328l-4.358,3.208,4.33,1.092c.453-1.533,1.967-3.3.027-4.3Z",
    transform: "translate(-181.835 -113.041)",
    fill: "url(#linear-gradient-25)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g28927",
    transform: "translate(212.975 113.913)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path28185",
    d: "M221.311,113.913a2.7,2.7,0,0,1,2.534,2.836,3.113,3.113,0,0,1-.278,1.286l-4.867,9.374-3.475-.464-1.193-2.168,5.2-9.654A2.466,2.466,0,0,1,221.311,113.913Z",
    transform: "translate(-214.033 -113.913)",
    fill: "url(#linear-gradient-26)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_538",
    "data-name": "Group 538",
    transform: "translate(9.813 13.496) rotate(180)",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path28187",
    d: "M.179,9.44c1.447,1.18,2.814,1.522,4.17.572L9.115,0l2,1.355-3.4,9.778L3.631,13.512,0,11.3Z",
    transform: "translate(-0.179 2.011)",
    fill: "url(#linear-gradient-27)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_539",
    "data-name": "Group 539",
    transform: "translate(9.813 13.496) rotate(180)",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path28189",
    d: "M.179,9.44c1.447,1.18,2.814,1.522,4.17.572L9.115,0l2,1.355-3.4,9.778L3.631,13.512,0,11.3Z",
    transform: "translate(-0.179 2.011)",
    fill: "url(#linear-gradient-27)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path28191",
    d: "M221.311,113.913a2.7,2.7,0,0,1,2.534,2.836,3.113,3.113,0,0,1-.278,1.286l-4.867,9.374-3.475-.464-1.193-2.168,5.2-9.654A2.466,2.466,0,0,1,221.311,113.913Z",
    transform: "translate(-214.033 -113.913)",
    fill: "url(#linear-gradient-29)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_540",
    "data-name": "Group 540",
    transform: "translate(9.813 13.496) rotate(180)",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path28193",
    d: "M.179,9.44c1.447,1.18,2.814,1.522,4.17.572L9.115,0l2,1.355-3.4,9.778L3.631,13.512,0,11.3Z",
    transform: "translate(-0.179 2.011)",
    fill: "url(#linear-gradient-27)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_541",
    "data-name": "Group 541",
    transform: "translate(9.813 13.496) rotate(180)",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path28195",
    d: "M.179,9.44c1.447,1.18,2.814,1.522,4.17.572L9.115,0l2,1.355-3.4,9.778L3.631,13.512,0,11.3Z",
    transform: "translate(-0.179 2.011)",
    fill: "url(#linear-gradient-27)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_546",
    "data-name": "Group 546",
    transform: "translate(222.788 127.409) rotate(180)",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path40074",
    d: "M4.358,4.3,0,1.092,4.33,0c.453,1.533,1.967,3.3.027,4.3Z",
    transform: "translate(5.145 -1.092)",
    fill: "url(#linear-gradient-32)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path7716",
    d: "M202.125,121.734c-15.023.012-27.616,12.711-29.186,29.433h58.392C229.759,134.437,217.155,121.735,202.125,121.734Z",
    transform: "translate(0 0.725)",
    fill: "url(#radial-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ellipse36630",
    d: "M3.038-.062a3.183,3.183,0,0,1,2.972,3.5,3.492,3.492,0,0,1-3.1,3.627,3.183,3.183,0,0,1-2.972-3.5A3.492,3.492,0,0,1,3.038-.062Z",
    transform: "matrix(0.985, -0.174, 0.174, 0.985, 212.211, 137.585)",
    fill: "url(#linear-gradient-33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ellipse36208",
    d: "M2.855-.058A2.991,2.991,0,0,1,5.648,3.235,3.282,3.282,0,0,1,2.732,6.643,2.991,2.991,0,0,1-.061,3.351,3.282,3.282,0,0,1,2.855-.058Z",
    transform: "matrix(0.985, -0.174, 0.174, 0.985, 212.425, 137.771)",
    fill: "url(#linear-gradient-34)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_547",
    "data-name": "Group 547",
    transform: "translate(172.938 122.46)",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path16883",
    d: "M177.7,136.506h8.6c2.762-3.525,7.363-4.078,13.962-4.078,10.755,0,14.244-1.77,17.261,4.078h9.07c-1.935-8.081-13.421-13.978-24.357-13.978C190.516,122.722,179.388,129.45,177.7,136.506Z",
    transform: "translate(-173.051 -121.66)",
    fill: "url(#linear-gradient-35)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path8454",
    d: "M2.874.067a3.3,3.3,0,0,1,2.944,3.4,2.964,2.964,0,0,1-2.8,3.262A3.3,3.3,0,0,1,.07,3.329,2.964,2.964,0,0,1,2.874.067Z",
    transform: "matrix(0.98, 0.201, -0.201, 0.98, 186.482, 136.665)",
    fill: "url(#radial-gradient-10)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_548",
    "data-name": "Group 548",
    transform: "translate(172.939 122.46)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path19040",
    d: "M125.587,96.2h6.146c1.974-2.518,6.485-2.434,10.423-2.434,6.419,0,9.728-1.744,11.884,2.434h6.48c-1.382-5.773-9.6-9.443-17.338-9.443C134.884,86.889,126.794,91.155,125.587,96.2Z",
    transform: "translate(-113.956 -85.885)",
    fill: "#a7d5aa"
  })), /*#__PURE__*/React.createElement("path", {
    id: "ellipse8456",
    d: "M2.855-.058A2.991,2.991,0,0,1,5.648,3.235,3.282,3.282,0,0,1,2.732,6.643,2.991,2.991,0,0,1-.061,3.351,3.282,3.282,0,0,1,2.855-.058Z",
    transform: "matrix(0.985, -0.174, 0.174, 0.985, 212.425, 137.771)",
    fill: "url(#linear-gradient-34)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_549",
    "data-name": "Group 549",
    transform: "translate(212.425 136.665)",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path31282",
    d: "M218.482,141.264c.459-.535,1.085-1.848.932-2.145.56-2.934-1.517-4.065-3.162-4.362l4.012-.258s.89,3.029.946,3.238C221.6,139.208,220.122,140.772,218.482,141.264Z",
    transform: "translate(-213.45 -134.756)",
    fill: "#083e15"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path32109",
    d: "M216.907,135.652a4.088,4.088,0,0,0-2.251-.305C215.474,135.021,216.177,134.707,216.907,135.652Z",
    transform: "translate(-0.987 1.958)",
    fill: "#445747"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_550",
    "data-name": "Group 550",
    transform: "translate(212.425 136.665)",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path32660",
    d: "M215.3,134.976c1.268-.581,2.2.3,3.19.922l-.207-1.535-3.054.148Z",
    transform: "translate(-213.425 -134.769)",
    fill: "#375f40"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path34195",
    d: "M216.618,135.553a.205.205,0,0,0-.051.005.23.23,0,0,0-.145.11.275.275,0,0,0,.063.355,3.108,3.108,0,0,1,.782.867.213.213,0,0,0,.319.058.276.276,0,0,0,.054-.354,3.651,3.651,0,0,0-.9-1,.213.213,0,0,0-.121-.044Zm-28.285.075a.212.212,0,0,0-.121.042,3.65,3.65,0,0,0-.9.995.276.276,0,0,0,.051.358.214.214,0,0,0,.32-.058,3.118,3.118,0,0,1,.784-.868.275.275,0,0,0,.063-.355.229.229,0,0,0-.145-.11h0a.226.226,0,0,0-.051-.005Zm2.171,3.416c.043-.048-.119.027-.162.075a2.883,2.883,0,0,1-.6.493.274.274,0,0,0-.08.35.216.216,0,0,0,.315.09,3.338,3.338,0,0,0,.693-.57.278.278,0,0,0,0-.362c-.043-.048-.2-.027-.162-.075Zm24.005-.012a.217.217,0,0,0-.162.075.278.278,0,0,0,0,.362,3.344,3.344,0,0,0,.694.57.216.216,0,0,0,.313-.09.274.274,0,0,0-.08-.35,2.879,2.879,0,0,1-.6-.493.217.217,0,0,0-.162-.075Z",
    transform: "translate(-0.339 2.007)",
    fill: "#afb4ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path39682",
    d: "M216.618,135.553a.205.205,0,0,0-.051.005.23.23,0,0,0-.145.11.275.275,0,0,0,.063.355,3.108,3.108,0,0,1,.782.867.213.213,0,0,0,.319.058.276.276,0,0,0,.054-.354,3.651,3.651,0,0,0-.9-1,.213.213,0,0,0-.121-.044Zm-28.285.075a.212.212,0,0,0-.121.042,3.65,3.65,0,0,0-.9.995.276.276,0,0,0,.051.358.214.214,0,0,0,.32-.058,3.118,3.118,0,0,1,.784-.868.275.275,0,0,0,.063-.355.229.229,0,0,0-.145-.11h0a.226.226,0,0,0-.051-.005Zm2.171,3.416c.043-.048-.119.027-.162.075a2.883,2.883,0,0,1-.6.493.274.274,0,0,0-.08.35.216.216,0,0,0,.315.09,3.338,3.338,0,0,0,.693-.57.278.278,0,0,0,0-.362c-.043-.048-.2-.027-.162-.075Zm24.005-.012a.217.217,0,0,0-.162.075.278.278,0,0,0,0,.362,3.344,3.344,0,0,0,.694.57.216.216,0,0,0,.313-.09.274.274,0,0,0-.08-.35,2.879,2.879,0,0,1-.6-.493.217.217,0,0,0-.162-.075Z",
    transform: "translate(-0.339 2.007)",
    fill: "#afb4ad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_551",
    "data-name": "Group 551",
    transform: "translate(172.938 122.46)",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path40556",
    d: "M191.486,123.854c-3.452,2.151-7.851,4.955-11.073,9.48l-.229-4.8Z",
    transform: "translate(-173.11 -121.537)",
    fill: "url(#linear-gradient-37)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_552",
    "data-name": "Group 552",
    transform: "translate(172.938 122.46)",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path41268",
    d: "M191.486,123.854c-3.452,2.151-7.851,4.955-11.073,9.48l-.229-4.8Z",
    transform: "translate(-173.11 -121.537)",
    fill: "url(#linear-gradient-37)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_553",
    "data-name": "Group 553",
    transform: "translate(172.938 122.46)",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path41276",
    d: "M191.486,123.854c-3.452,2.151-7.851,4.955-11.073,9.48l-.229-4.8Z",
    transform: "translate(-173.11 -121.537)",
    fill: "url(#linear-gradient-37)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_554",
    "data-name": "Group 554",
    transform: "translate(172.938 122.46)",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path41278",
    d: "M191.486,123.854c-3.452,2.151-7.851,4.955-11.073,9.48l-.229-4.8Z",
    transform: "translate(-173.11 -121.537)",
    fill: "url(#linear-gradient-37)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_555",
    "data-name": "Group 555",
    transform: "translate(231.352 151.893) rotate(180)",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path41288",
    d: "M11.3,9.48C7.851,7.33,3.451,4.526.229,0L0,4.8Z",
    transform: "translate(7.074 17.636)",
    fill: "url(#linear-gradient-41)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_556",
    "data-name": "Group 556",
    transform: "translate(231.352 151.893) rotate(180)",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path41290",
    d: "M11.3,9.48C7.851,7.33,3.451,4.526.229,0L0,4.8Z",
    transform: "translate(7.074 17.636)",
    fill: "url(#linear-gradient-41)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidLicense);
export default __webpack_public_path__ + "static/media/androidLicense.eb57f2e5c4885051e11eb31b8040a2b5.svg";
export { ForwardRef as ReactComponent };